export default __webpack_public_path__ + "static/media/6f32c65c-e6c9-46af-b323-2f38aec085bd.2a3331ce.JPG";